var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.searchOptions
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(
              _vm.searchOptions && _vm.searchOptions.optionsWhere,
              function(item) {
                return _c(
                  "div",
                  {
                    key: item.key,
                    staticClass: "status",
                    class: { active: _vm.where === item.key },
                    on: {
                      click: function($event) {
                        return _vm.selectWhere(item.key)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(item.label) +
                        "(" +
                        _vm._s(_vm.where == item.key ? _vm.tempCount : 0) +
                        ")\n    "
                    )
                  ]
                )
              }
            ),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商品货号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_no", $$v)
                                        },
                                        expression: "form.goods_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "sku" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.sku,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sku", $$v)
                                        },
                                        expression: "form.sku"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商品名称" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.goods_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_name", $$v)
                                        },
                                        expression: "form.goods_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "商家" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.supply_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "supply_name", $$v)
                                        },
                                        expression: "form.supply_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "市场" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.market_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "market_name", $$v)
                                        },
                                        expression: "form.market_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "品牌" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.brand_name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "brand_name", $$v)
                                        },
                                        expression: "form.brand_name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "代采单号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.woid,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "woid", $$v)
                                        },
                                        expression: "form.woid"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "包裹号",
                                        clearable: ""
                                      },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.package_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "package_no", $$v)
                                        },
                                        expression: "form.package_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "批次号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.pici_no,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "pici_no", $$v)
                                        },
                                        expression: "form.pici_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "打标id" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.dbid,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "dbid", $$v)
                                        },
                                        expression: "form.dbid"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              multiple: "",
                                              placeholder: "状态"
                                            },
                                            model: {
                                              value: _vm.form.status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "form.status"
                                            }
                                          },
                                          _vm._l(
                                            _vm.searchOptions &&
                                              _vm.searchOptions.optionsStatus,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "是否工单商品"
                                            },
                                            model: {
                                              value: _vm.form.is_work_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_work_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.is_work_id"
                                            }
                                          },
                                          _vm._l(_vm.is_work_id, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "工作台" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.desk_no,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "desk_no", $$v)
                                            },
                                            expression: "form.desk_no"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "代采欠货打标方式"
                                            },
                                            model: {
                                              value: _vm.form.da_biao_method,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "da_biao_method",
                                                  $$v
                                                )
                                              },
                                              expression: "form.da_biao_method"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                value: "",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions &&
                                                _vm.searchOptions
                                                  .optionPurchaseDaBiaoMethod,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "批次创建方式"
                                            },
                                            model: {
                                              value: _vm.form.create_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "create_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.create_type"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions &&
                                                _vm.searchOptions
                                                  .optionsPiciType,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "异常来源" },
                                            model: {
                                              value:
                                                _vm.form.exception_dbid_source,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "exception_dbid_source",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.exception_dbid_source"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                value: "",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions &&
                                                _vm.searchOptions
                                                  .exceptionSourceOp,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.key
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "次品组"
                                        },
                                        model: {
                                          value: _vm.form.dgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dgid", $$v)
                                          },
                                          expression: "form.dgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.searchOptions &&
                                            _vm.searchOptions.dg_group,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "退换货负责人"
                                        },
                                        model: {
                                          value: _vm.form.dpc_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dpc_id", $$v)
                                          },
                                          expression: "form.dpc_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.searchOptions &&
                                            _vm.searchOptions.option_dgm,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "售后退供员"
                                        },
                                        model: {
                                          value: _vm.form.refunder_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "refunder_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.refunder_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.searchOptions &&
                                            _vm.searchOptions.dgm_refunder,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "款号" },
                                      model: {
                                        value: _vm.form.goods_kh,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "goods_kh", $$v)
                                        },
                                        expression: "form.goods_kh"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "是否买赔商品"
                                        },
                                        model: {
                                          value: _vm.form.is_compensate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_compensate",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_compensate"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: 0 }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.searchOptions &&
                                            _vm.searchOptions
                                              .optionIsCompensate,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "代采计划单号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.planid,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "planid", $$v)
                                        },
                                        expression: "form.planid"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _vm.searchOptions
                          ? _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "入库时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择仓库" },
                                        model: {
                                          value: _vm.form.origin,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "origin", $$v)
                                          },
                                          expression: "form.origin"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsOrigin,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择仓区" },
                                        model: {
                                          value: _vm.form.where,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "where", $$v)
                                          },
                                          expression: "form.where"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsWhere,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "选择代采组"
                                        },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsPg,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.searchOptions
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "订单负责人"
                                            },
                                            model: {
                                              value: _vm.form.order_owner,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "order_owner",
                                                  $$v
                                                )
                                              },
                                              expression: "form.order_owner"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.searchOptions &&
                                                _vm.searchOptions.owner_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择买手组" },
                                        model: {
                                          value: _vm.form.picker_group,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "picker_group",
                                              $$v
                                            )
                                          },
                                          expression: "form.picker_group"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsMs,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "选择入库来源"
                                        },
                                        model: {
                                          value: _vm.form.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "type", $$v)
                                          },
                                          expression: "form.type"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsType,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "不良品类型"
                                        },
                                        model: {
                                          value: _vm.form.blp_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "blp_type", $$v)
                                          },
                                          expression: "form.blp_type"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsblp,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择次品等级" },
                                        model: {
                                          value: _vm.form.the_level,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "the_level", $$v)
                                          },
                                          expression: "form.the_level"
                                        }
                                      },
                                      _vm._l(
                                        _vm.searchOptions &&
                                          _vm.searchOptions.optionsLevel,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.label
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "是否带配件/套装"
                                        },
                                        model: {
                                          value: _vm.form.has_suit_parts,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "has_suit_parts",
                                              $$v
                                            )
                                          },
                                          expression: "form.has_suit_parts"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "0", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { value: "1", label: "是" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { value: "2", label: "否" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v(
                    "\n      数据汇总    入库总数" +
                      _vm._s(_vm.resData.stock_total_num) +
                      "件        入库金额：¥" +
                      _vm._s(_vm.resData.stock_total_price) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "30px",
                      "line-height": "30px",
                      padding: "0 25px",
                      "align-items": "center",
                      position: "relative"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          right: "0",
                          top: "0"
                        }
                      },
                      [
                        _vm.show_exc_time == 1
                          ? _c("el-date-picker", {
                              attrs: {
                                size: "mini",
                                format: "yyyy-MM-dd HH:mm:ss",
                                type: "datetimerange",
                                "default-time": ["06:00:00", "06:00:00"],
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期"
                              },
                              model: {
                                value: _vm.form.excetion_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "excetion_time", $$v)
                                },
                                expression: "form.excetion_time"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: { click: _vm.oweRebackApply }
                          },
                          [_vm._v("\n            申请恢复欠货\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "-18px" },
                            attrs: { type: "info", size: "mini" },
                            on: {
                              click: function($event) {
                                _vm.show_exc_time = !_vm.show_exc_time
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-date" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "info", size: "mini" },
                            on: { click: _vm.outputExcetionData }
                          },
                          [_vm._v("\n            异常日志导出\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: { click: _vm.markExcept }
                          },
                          [_vm._v("\n            标记异常\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: { click: _vm.markNormal }
                          },
                          [_vm._v("\n            恢复正常\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.importDbid(2)
                              }
                            }
                          },
                          [_vm._v("\n            批量导入标记异常")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.importDbid(1)
                              }
                            }
                          },
                          [_vm._v("\n            批量导入恢复正常")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "auto" },
                            attrs: { type: "info", size: "mini" },
                            on: { click: _vm.output }
                          },
                          [_vm._v("导出")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "50" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_img",
                                label: "商品图片",
                                width: "100",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                              overflow: "hidden",
                                              cursor: "pointer",
                                              margin: "auto"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: {
                                                src: scope.row.goods_img
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1325509903
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _vm.where === 3
                              ? _c("el-table-column", {
                                  key: _vm.blp_img,
                                  attrs: {
                                    prop: "blp_img",
                                    label: "换回商品图片",
                                    width: "120",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "viewer",
                                                    rawName: "v-viewer"
                                                  }
                                                ],
                                                staticStyle: {
                                                  width: "40px",
                                                  height: "40px",
                                                  overflow: "hidden",
                                                  cursor: "pointer",
                                                  margin: "auto"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "100%",
                                                    height: "100%"
                                                  },
                                                  attrs: {
                                                    src: scope.row.blp_img
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3270613857
                                  )
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "package_no",
                                label: "包裹号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "package_create_time",
                                label: "包裹生成时间",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pici_no",
                                label: "批次号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pici_create_type",
                                label: "批次创建方式",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "desk_no",
                                label: "工作台",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_gift",
                                label: "是否赠品",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_cross_order_dbid",
                                label: "是否跨仓调拨",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dbid",
                                label: "打标id",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.dbid) +
                                              "\n              "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        scope.row.is_compensate_msg
                                          ? _c(
                                              "el-tag",
                                              { attrs: { color: "009DD9" } },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      scope.row
                                                        .is_compensate_msg
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2299607553
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sku_text",
                                label: "货号/颜色/尺码",
                                width: "200px",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sku",
                                label: "sku",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "has_suit_parts",
                                label: "是否带配件/套装",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "价格",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "market",
                                label: "商家/品牌/市场",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pg",
                                label: "买手组/代采组",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "owner_admin_name",
                                label: "订单负责人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dg_group_name",
                                label: "次品组",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dgm_name",
                                label: "退换货负责人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "refunder",
                                label: "售后退供员",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "dispute_goods_str",
                                label: "争议商品",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "purchase_da_biao_method",
                                label: "打标方式",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _vm.where === 3
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "category",
                                    label: "类别",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_stock_source",
                                label: "入库来源",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              row.stock_in_record_stock_source
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        row.is_transit_formal
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#006cff"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      row.is_transit_formal
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2124719090
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sdbr_text",
                                label: "是否爆版打标",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "blp_type",
                                label: "不良品类型",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "woid",
                                label: "代采订单",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "psp_id",
                                label: "前置仓计划编号",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "ow",
                                label: "仓库",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "source_where_text",
                                label: "原库区",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status_text",
                                label: "状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "exception_dbid_source",
                                label: "异常来源",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "exchange_calc_date",
                                label: "开始计算时间",
                                width: "100",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "handle",
                                label: "入库时间/入库人",
                                width: "100",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.curPage,
                            background: "",
                            layout: "total, prev, pager, next, jumper ",
                            total: _vm.resData.count,
                            "page-size": 10
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.curPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.curPage = $event
                            },
                            "current-change": _vm.handleCurrentChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "批量导入恢复正常", visible: _vm.dialogNormal },
          on: {
            "update:visible": function($event) {
              _vm.dialogNormal = $event
            }
          }
        },
        [
          _c(
            "el-upload",
            {
              ref: "upload2",
              staticClass: "upload-demo",
              attrs: {
                action: _vm.action2,
                limit: 1,
                "file-list": _vm.fileListNor,
                data: { markType: 2 },
                "auto-upload": false,
                "on-success": _vm.submitSuccess,
                "with-credentials": ""
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("选择文件")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [
                  _vm._v(
                    "\n        请先下载模板,跟模板一样格式,并且确保每行数据正确,不能为空\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "red" } }, [
            _vm._v("\n      " + _vm._s(_vm.uploadErrorMsg) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small", type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.importDbid(3, 2)
                    }
                  }
                },
                [_vm._v("下载模板")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small", type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.submitUpload(2)
                    }
                  }
                },
                [_vm._v("上传到服务器")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogNormal = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入标记异常",
            visible: _vm.dialogExcept,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogExcept = $event
            },
            close: _vm.handleBatchExceptionClose
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogExcept = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirmBatchException }
                    },
                    [_vm._v("\n        确定\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "formBatchException",
              attrs: { model: _vm.formBatchException }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "file" } },
                [
                  _c("ys-upload-combo", {
                    attrs: {
                      "download-temp": _vm.handleTemplateDownload,
                      "btn-upload": "选择文件",
                      "btn-list": ""
                    },
                    model: {
                      value: _vm.formBatchException.file,
                      callback: function($$v) {
                        _vm.$set(_vm.formBatchException, "file", $$v)
                      },
                      expression: "formBatchException.file"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "请先下载模板,跟模板一样格式,并且确保每行数据正确,不能为空"
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "置换欠货", visible: _vm.exChange.show },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.exChange, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.exChange.search_form.select_key,
                        callback: function($$v) {
                          _vm.$set(_vm.exChange.search_form, "select_key", $$v)
                        },
                        expression: "exChange.search_form.select_key"
                      }
                    },
                    _vm._l(_vm.exChange.sekectKeyOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "请输入" +
                        _vm.exChange.sekectKeyOptions[
                          _vm.exChange.search_form.select_key - 1
                        ].label
                    },
                    model: {
                      value: _vm.exChange.search_form.select_val,
                      callback: function($$v) {
                        _vm.$set(_vm.exChange.search_form, "select_val", $$v)
                      },
                      expression: "exChange.search_form.select_val"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "infor" },
                  on: { click: _vm.exChangeOweFetch }
                },
                [_vm._v("查询")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "exchange_table",
              attrs: { data: _vm.exChange.rs, height: "400px" },
              on: {
                select: _vm.exChangeSelection,
                "select-all": function() {
                  _vm.$message.error("请勿全选")
                  _vm.$refs.exchange_table.clearSelection()
                }
              }
            },
            [
              _c("el-table-column", { attrs: { type: "selection" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "款号", prop: "goods_kh" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "货号/颜色/尺码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.goods_no) +
                            "/" +
                            _vm._s(scope.row.co_val) +
                            "/" +
                            _vm._s(scope.row.si_val) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "欠货类型" } }, [
                _c("span", [_vm._v(" 代采欠货 ")])
              ]),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "欠货数量", prop: "owe_num" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.exChange.show = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.exChangeOweDo }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申恢复欠货",
            visible: _vm.isShowRebackDialog,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowRebackDialog = $event
            },
            close: function($event) {
              _vm.isShowRebackDialog = false
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "80px" } },
            [
              _c("el-form-item", { attrs: { label: "申请数量: " } }, [
                _vm._v(_vm._s(_vm.multipleSelection.length))
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "申请说明: " } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 6 },
                    model: {
                      value: _vm.oweRebackApplyRemark,
                      callback: function($$v) {
                        _vm.oweRebackApplyRemark = $$v
                      },
                      expression: "oweRebackApplyRemark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isShowRebackDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.doApplyReback }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "标记异常",
            visible: _vm.isShowAbnormalSourceDialog,
            "close-on-click-modal": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAbnormalSourceDialog = $event
            },
            close: _vm.handleMarkExceptClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formException",
              attrs: { model: _vm.formException, "label-width": "80px" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "异常来源",
                    prop: "exceptionSource",
                    rules: _vm.rules.ruleChange
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formException.exceptionSource,
                        callback: function($$v) {
                          _vm.$set(_vm.formException, "exceptionSource", $$v)
                        },
                        expression: "formException.exceptionSource"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v("改标异常")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("其他异常")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "异常原因",
                    prop: "exceptionReasonSingle",
                    rules: _vm.rules.ruleChange
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.formException.exceptionReasonSingle,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formException,
                            "exceptionReasonSingle",
                            $$v
                          )
                        },
                        expression: "formException.exceptionReasonSingle"
                      }
                    },
                    _vm._l(_vm.optionsMap.reasonList, function(item) {
                      return _c("el-option", {
                        key: item.rdid,
                        attrs: { label: item.rdname, value: item.rdid }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "责任部门", prop: "responsibilityDeptSingle" }
                },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.optionsMap.departmentList,
                      props: { checkStrictly: true }
                    },
                    model: {
                      value: _vm.formException.responsibilityDeptSingle,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formException,
                          "responsibilityDeptSingle",
                          $$v
                        )
                      },
                      expression: "formException.responsibilityDeptSingle"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "责任人", prop: "responsibilityPersonal" } },
                [
                  _c("ys-input", {
                    attrs: {
                      maxlength: _vm.constantMap.maxName,
                      placeholder: "最长" + _vm.constantMap.maxName + "个字符"
                    },
                    model: {
                      value: _vm.formException.responsibilityPersonal,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formException,
                          "responsibilityPersonal",
                          $$v
                        )
                      },
                      expression: "formException.responsibilityPersonal"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isShowAbnormalSourceDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirmException }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("商品入库列表")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57b49ea5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b49ea5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockInList.vue
// module id = null
// module chunks = 